export default __webpack_public_path__ + "static/media/design_services.4f025213.svg";